import {
  AfterViewInit,
  Component,
  Input,
  ViewChild,
  inject
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { Job_EmbeddedVisitProjection, Visit } from "@app/models/rest/visit";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import {
  DateColumnConfig,
  RowExpanderConfig,
  TemplateColumnConfig
} from "@bryntum/grid-thin";
import { ActivatedRoute, Router } from "@angular/router";
import { VisitStore } from "@app/services/store/visit-store";
import { VisitStatus } from "@app/models/enums/visit-status.enum";
import { MatDialog } from "@angular/material/dialog";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { Location, NgClass } from "@angular/common";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { Meeting_DetailProjection } from "@app/models/rest/meeting";
import { MeetingStore } from "@app/services/store/meeting-store";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { PropertyInfoComponent } from "../../../integrations/urm/views/property-info/property-info.component";
import { GridComponent as GridComponent_1 } from "../../shared/base-pages/base-data-table-page/grid.component";

class VisitSortStruct {
  AUTO: Job_EmbeddedVisitProjection[];
  REFERRED: Job_EmbeddedVisitProjection[];
  NEW: Job_EmbeddedVisitProjection[];
  BOOKED: Job_EmbeddedVisitProjection[];
  IN_PROGRESS: Job_EmbeddedVisitProjection[];
  COMPLETED: Job_EmbeddedVisitProjection[];
  CANCELLED: Job_EmbeddedVisitProjection[];
}
@Component({
  selector: "app-meeting-detail-page",
  templateUrl: "./meeting-detail-page.component.html",
  styleUrls: ["./meeting-detail-page.component.scss"],
  imports: [
    MatToolbar,
    MatIconButton,
    MatIcon,
    PropertyInfoComponent,
    GridComponent_1,
    NgClass
  ]
})
export class MeetingDetailPageComponent implements AfterViewInit {
  route = inject(ActivatedRoute);
  meetingStore = inject(MeetingStore);
  visitStore = inject(VisitStore);
  router = inject(Router);
  dialog = inject(MatDialog);
  serverErrorHandler = inject(ServiceErrorHandlerService);
  private _location = inject(Location);
  config = inject(ClientConfigService);

  meeting: Meeting_DetailProjection;
  source: "detail" | "planning";
  loading: boolean = true;
  topMessage: string = "Loading...";
  public VisitStatus = VisitStatus;
  visitTableSource: MatTableDataSource<Job_EmbeddedVisitProjection>;
  initialised = false;
  @ViewChild(GridComponent, { static: false })
  public visitGrid: GridComponent;

  public rowExpanderConfig: Partial<RowExpanderConfig> = {
    columnPosition: "last",
    renderer: async ({ record }) => {
      console.log("Rendering visit card for record", record);
      const { id } = record;
      console.log("Extracted ID", id);
      return `<visit-card-component visit-id="${id}" style="width:100%"></visit-card-component>`;
    }
  };

  @Input()
  public visitColumns: (TemplateColumnConfig | DateColumnConfig)[] = [
    {
      field: "id",
      text: "Visit ID",
      editor: false,
      sortable: true
    },
    // {
    //   width: 700,
    //   htmlEncode: false,
    //   renderer({ record }) {
    //     console.log("Rendering visit card for record", record);
    //     const { id } = record;
    //     console.log("Extracted ID", id);
    //     return `<visit-card-component visitid="${id}"></visit-card-component>`;
    //   }
    // },
    {
      field: "visitStatus",
      text: "Status",
      filterable: true
    },
    {
      field: "appointmentStart",
      text: "Appointment Start",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    },
    {
      field: "appointmentEnd",
      text: "Appointment End",
      flex: 1,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      editor: false
    }
  ];

  visits: VisitSortStruct = new VisitSortStruct();
  displayedColumns: string[] = [
    "id",
    "visitStatus",
    "visitType",
    "appointment",
    "schedule",
    "attendance",
    "actions"
  ];
  animating = true;
  private meetingId: number;

  constructor() {
    this.route.params.subscribe((params) => {
      if (params["id"]) {
        this.loadMeeting(params["id"]);
      }
      if (params["source"]) {
        this.source = params["source"];
      }
    });
  }

  updateGrid(): void {
    console.log("updating grid");
    if (this.visitGrid) {
      console.log(
        "Found grid, calling clear and add for visits",
        this.meeting.visitList
      );
      this.visitGrid.clearGrid();
      this.visitGrid.addRow(this.meeting.visitList);
    }
  }

  loadMeeting(id: number): void {
    this.meetingId = id;
    this.meetingStore
      .loadSingleProjection(Meeting_DetailProjection, id, "detail")
      .then((value) => {
        console.log("Meeting detail page loaded", value);
        this.meeting = value;
        this.visitTableSource =
          new MatTableDataSource<Job_EmbeddedVisitProjection>(
            this.meeting.visitList
          );
        let processed = new VisitSortStruct();
        // this.updateGrid();

        this.meeting?.visitList?.forEach((visit) => {
          processed[visit.visitStatus]
            ? processed[visit.visitStatus].push(visit)
            : (processed[visit.visitStatus] = [visit]);
        });
        this.visits = processed;

        this.loading = false;
        this.updateGrid();
        // this.updateGrid();
      })
      .catch((reason) => {
        this.serverErrorHandler.handleError(reason);
      });
  }

  ngAfterViewInit(): void {
    console.log("After view init");
    this.initialised = true;
    this.updateGrid();
  }

  returnToMenu() {
    switch (this.source) {
      case "detail":
        this._location.back();
        // this.router.navigate(['/jobs']).then();
        break;
      case "planning":
        this.router.navigate(["/planning"]).then();
        break;
    }
  }

  cancelVisit(visit: Visit) {
    this.loading = true;
    this.visitStore.loadSingle(visit.id).then((value: Visit) => {
      value.visitStatus = VisitStatus.CANCELLED;
      this.visitStore.update(value).subscribe(() => {});
    });
  }

  processGridEvent($event: any) {
    if ($event.type === "ready") {
      console.log("Grid is ready", this.visitGrid);
      this.loadMeeting(this.meetingId);
    }
  }
}
